// @flow
import React, { Component } from 'react';

import './MenuMaker.css';
import '../../node_modules/react-grid-layout/css/styles.css'
import '../../node_modules/react-resizable/css/styles.css'
import ReactGridLayout from '../react-grid-layout/index-dev'
import firebaseMenuMaker from '../firebase-menumaker'
import populateLinkedBlocksWithDishes from './populateLinkedBlocksWithDishes'
import MenuLibrary from './MenuLibrary'
import Blocks from './Blocks'
import _ from 'underscore'
import LayoutGuideBackground from './LayoutGuideBackground'
import {get, keyBy, max, map} from 'lodash'
import request from 'superagent'
import Slider from 'rc-slider/lib/Slider';
import 'rc-slider/assets/index.css';
import {Style} from './MenuCustomCSS'

const StorageContext = React.createContext()

class MenuMaker extends Component {
  constructor() {
    super();
    this.state = {
      menu: null,
      edited: false,
      productsIndex: null,
      items: [],
      categories: [],
      layout: null,
      blocks: [],
      width: null,
      height: null,
      dishFontSize: '',
      marginX: null,
      marginY: null,
      screenshot: null,
      canvasScale: 1,
      selectedBlocks: {

      }
    }
    this.onLayoutChange = this.onLayoutChange.bind(this)
    this.handleGridPropChange = this.handleGridPropChange.bind(this)
    this.handleDeleteBlock = this.handleDeleteBlock.bind(this)
    this.handleAddHeaderBlock = this.handleAddHeaderBlock.bind(this)
    this.handleCreateImage = this.handleCreateImage.bind(this)
  }
  handleScaleChange = (canvasScale) => {
    this.setState({canvasScale: canvasScale / 100})
  }
  getCanvasScaleToFit = () => {
    // console.log('scaleing')
    let viewportWidth = window.innerWidth
    let canvasWidth = this.state.width
    let scale = 1
    if (canvasWidth > viewportWidth) {
      scale = viewportWidth / (canvasWidth + 70)
    }
    console.log(scale)
    this.setState({canvasScale: scale})
  }
  onLayoutChange(layout) {
    console.log('layout changed', layout)
    this.setState({edited: true})
    let layoutObject = {}
    layout.forEach(l => {
      // remove undefined
      let lClone = Object.assign({}, l)
      _.each(lClone, (value, key) => {

        if (value === undefined) {
          delete lClone[key]
        }
      })
      layoutObject[l.i] = lClone
    })
    // console.log(layout)
    this.menusRef.child('layout').set(layoutObject)
  }
  syncLayout = () => {
    if (this.menusRef) {
      // when switching between pages, turn off other page's sync
      this.menusRef.off()
    }
    // get grid menus
    if (this.props.tvId) {
      this.menusRef = firebaseMenuMaker.database().ref(`tvProductions/${this.props.shopId}/${this.props.tvId}/design/pages/${this.props.pageId}`)

    } else {
      this.menusRef = firebaseMenuMaker.database().ref(`designs/${this.props.designId}/pages/${this.props.pageId}`)
    }
    this.menusRef.on('value', (snapshot) => {
      // if (!snapshot.val()) { return }
      let { blocks={}, layout={}, width=850, height=1100, marginX=0, marginY=0, dishFontSize="0.8em" } = snapshot.val() || {}
      let blocksArray = _.map(blocks, (block, id) => {
        return(Object.assign({}, block, {id}))
      })
      // let layoutArray = Object.values(layout)
      this.setState({ blocks: blocksArray, layout, width, height, marginX, marginY, dishFontSize }, () => {
        // console.log(document.querySelectorAll('img'))
      })
    })
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.pageId !== this.props.pageId) {
      // get screenshot for previous page
      if (prevState.edited) {
        const { designId, shopId, pageId }  = prevProps
        const { width=850, height=1100 } = prevState
        const deviceScaleFactor = 0.5
        this.handleCreateImage({ designId, shopId, pageId, width, height, deviceScaleFactor })
      }
      // clear screen
      this.setState({ layout: null })
      this.setState({edited: false})
      // sync new layout
      this.syncLayout()
    }
  }
  componentDidMount() {
    let restaurantId = this.props.shopId
    let cacheKey = `${restaurantId}-full`
    let fetchLink = `https://afoodapart.com/api/menu/${restaurantId}`
    if (restaurantId === 'pablitostacosvannuys') {

       fetchLink = `https://afoodapart.com/api/menu/${restaurantId}`
    }
    // let fetchLink = `https://firestore.googleapis.com/v1beta1/projects/avocadoftw-c5639/databases/(default)/documents/cache/${cacheKey}`
    // get restaurant data
    fetch(fetchLink)
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        // let menu = JSON.parse(get(json, 'fields.shop.stringValue', "{}")).menu
        let menu = json.menu
        let productsIndex = {};
        (menu.subMenus || []).forEach(({products=[]}) => {
          products.forEach((p) => (productsIndex[p.id] = p))
        })
        this.setState({ menu: menu, productsIndex })
      })
      .catch((err)=> { console.log(err) })
    this.syncLayout()
  }
  handleGridPropChange(event) {
    let {name, value} = event.target
    console.log({name, value})
    this.menusRef.update({[name]: value})
  }
  handleAddToBlocksRef = (block: { type: string, content: {} }) => {
    this.menusRef.child('blocks').push(block)
  }
  handleAddDish = (linked_id: string) => {
    this.handleAddToBlocksRef({
      type: 'dish',
      linked: true,
      linked_id
    })
  }
  handleAddTextDish = (linked_id: string) => {
    this.handleAddToBlocksRef({
      type: 'dish-text',
      linked: true,
      linked_id
    })
  }
  handleAddImageDish = (linked_id: string) => {
    this.handleAddToBlocksRef({
      type: 'dish-image',
      linked: true,
      linked_id
    })
  }
  handleAddTextList = (linked_category_id: string) => {
    this.handleAddToBlocksRef({
      type: 'text-list',
      linked: true,
      linked_category_id
    })
  }
  handleAddPhoto = (photo: {}) => {
    console.log('add')
    this.handleAddToBlocksRef({ type: 'photo', content: photo })
  }
  handleCopyBlocks = () => {
    let {layout, blocks, selectedBlocks} = this.state
    // let selectedLayoutArray = Object.values(layout).filter(l => selectedBlocks[l.i])
    let selectedBlocksArrayWithEmbeddedLayout =
      blocks.filter(b => selectedBlocks[b.id])
            .map(b => Object.assign({}, b, _.pick(layout[b.id], ['x', 'y', 'w', 'h'])))

    global.__AFA_GRID_BLOCK_PASTEBOARD__ = {selectedBlocksArrayWithEmbeddedLayout}
  }
  handlePasteBlocks = () => {
    const paste = global.__AFA_GRID_BLOCK_PASTEBOARD__
    if (!paste) { return }

    const {selectedBlocksArrayWithEmbeddedLayout} = paste
    console.log(selectedBlocksArrayWithEmbeddedLayout)
    selectedBlocksArrayWithEmbeddedLayout.forEach(b => {
      this.menusRef.child('blocks').push(b)
    })


    // onLayoutChange()
  }
  handleAddHeaderBlock ({title, description}) {
    this.menusRef.child('blocks').push({
      type: 'header',
      content: {
        title: title || 'header',
        description: description || ''
      }
    })
  }
  handleDeleteBlock(blockId) {
    this.menusRef.child('blocks').child(blockId).remove()
  }
  async handleCreateImage({ designId, shopId, pageId, width, height, deviceScaleFactor }) {
    console.log('creating new preview')
    await this.setState({ screenshot: null })
    let html = document.documentElement.outerHTML
    let url = "https://lcicj3wbt1.execute-api.us-east-1.amazonaws.com/dev/hello-world"
    const json = { designId, shopId, pageId, width, height, deviceScaleFactor }
    // console.log('sending', json)
    let response = await request.post(url).set('Content-Type', 'application/json').send(json)
    console.log(response.body)
    // firebaseMenuMaker.database()
    //   .ref(`shopsInfo/${this.props.shopId}/designsIndex/${this.props.designId}/pages/${this.props.pageId}/preview`)
    //   .set(response.body)
  }
  handleToggleSelection = (blockId, e) => {
    let oldSelectedBlocks = this.state.selectedBlocks
    this.setState({
      selectedBlocks: Object.assign(
        oldSelectedBlocks,
        { [blockId]: !oldSelectedBlocks[blockId] }
      )
    }, () => console.log(this.state))
  }
  handleClearSelection = (e) => {
    this.setState({ selectedBlocks: {} })
  }
  handleClickBlockWrapper = (blockId, e) => {
    e.stopPropagation()
    if (e.getModifierState("Meta") || e.getModifierState("Control")) {
      this.handleToggleSelection(blockId, null)
    }
  }
  componentWillUnmount() {
    this.menusRef.off()
  }
  handleMoveUp = () => {
    this.setState({
      layout: _.mapObject(this.state.layout, (item) => {
        return(Object.assign({}, item, { y: item.y -1  }))
      })
    })
  }
  render() {
    const {blocks, layout, productsIndex, menu, selectedBlocks} = this.state
    let colHeight = 1
    let cols = Math.round((Number(this.state.width) || 850) / colHeight)
    let rowHeight = 1

    if (!layout || !productsIndex) {
      return(
        <div>Loading...</div>
      )
    }
    const populatedBlocks = populateLinkedBlocksWithDishes(blocks, productsIndex, menu) || []
    // console.log(populatedBlocks)
    let yEnd = max(map(layout, (l) => ((l.y || 0) + (l.h || 0)))) || 0
    // console.log('yEnd', yEnd)
    const layoutArrayWithDefaultsDimensions = populatedBlocks.map((block) => {
      if (layout[block.id]) {
        return layout[block.id]
      } else {
        // default block location and size
        return { i: block.id, x: block.x || 0, y: block.y || yEnd, w: block.w || 200, h: block.h || 100}
      }
    })

    return (
      <StorageContext.Provider value={{
        blocksRef: this.menusRef.child('blocks'),
        handleAddDish: this.handleAddDish,
        handleAddPhoto: this.handleAddPhoto,
        handleAddTextDish: this.handleAddTextDish,
        handleAddImageDish: this.handleAddImageDish,
        handleAddTextList: this.handleAddTextList,
        handleAddHeaderBlock: this.handleAddHeaderBlock,
      }}>

      <Style path={`css/${this.props.shopId}/global`}/>

      <div className="wrapper">
        {/* <span>debug: {this.props.pageId}</span> */}
        <div className="tool-bar no-print">
          <div className="view-size">
            <input type="text" name="width" value={this.state.width} onChange={this.handleGridPropChange}/> x
            <input type="text" name="height" value={this.state.height} onChange={this.handleGridPropChange}/>
            dish font size:
            <input type="text" name="dishFontSize" value={this.state.dishFontSize} onChange={this.handleGridPropChange}/>
            {/* <input type="text" name="height" value={this.state.height} onChange={this.handleGridPropChange}/> */}

            <div className="tool-bar__canvas-scale-slider-wrapper">
              <Slider
                min={10}
                max={200}
                value={this.state.canvasScale * 100}
                onChange={this.handleScaleChange} />
            </div>
          </div>
          {/* <div className="extra">
            Margin between products:
            left/right <input type="text" name="marginX" value={this.state.marginX} onChange={this.handleGridPropChange}/>
            top/bottom <input type="text" name="marginY" value={this.state.marginY} onChange={this.handleGridPropChange}/>
          </div> */}
          <div className="custom-objects">
            <button onClick={this.handleAddHeaderBlock}>Add Header Block</button>
            <button onClick={this.handleCopyBlocks}>Copy Blocks</button>
            <button onClick={this.handlePasteBlocks}>Paste Blocks</button>
            <button onClick={this.handleCreateImage}>Create Image</button>

            {this.state.screenshot &&
              <div className="preview-container">
                <img src={`data:image/jpeg;base64,${this.state.screenshot}`} alt=""/>
              </div>}
          </div>
        </div>

        <div className="rgl-container"
          style={{
            transform: `scale(${this.state.canvasScale})`
          }}
          onClick={this.handleClearSelection}>

            <div className="bottom-line no-print" style={{
              width: "100%",
              height: "1px",
              backgroundColor: "green",
              position: 'absolute',
              top: this.state.height + "px",
              left: 0,
              zIndex: 1
            }}></div>

          <div className="right-line no-print" style={{
              height: "100%",
              width: "1px",
              backgroundColor: "green",
              position: 'absolute',
              top: 0,
              left: this.state.width + "px",
              zIndex: 1
            }}> </div>

            <LayoutGuideBackground
              id={'layout-guide'}
              cols={cols}
              rowHeight={rowHeight}
              width={this.state.width}
              height={this.state.height}
            />

          <div className="page__background"
            style={{
              width: this.state.width + "px",
              height: this.state.height + "px",
              position: 'absolute',
              top: 0,
              left: 0,


            }}
            >
              {/* hi */}
          </div>

          <ReactGridLayout
            canvasScale={this.state.canvasScale}
            className="layout"
            selectedBlocks={this.state.selectedBlocks}
            onLayoutChange={this.onLayoutChange}
            compactType={null}
            preventCollision={true}
            draggableHandle='.draggable-handle'
            margin={[Number(this.state.marginX), Number(this.state.marginY)]}
            layout={layoutArrayWithDefaultsDimensions}
            cols={cols}
            rowHeight={rowHeight}
            width={Number(this.state.width)}>

            {populatedBlocks.map(b => {
              return(
              <div
                style={{
                  fontSize: this.state.dishFontSize
                }}
                className={"block-wrapper" + (selectedBlocks[b.id] ? ' selected-block' : '') }
                key={b.id}
                onClick={this.handleClickBlockWrapper.bind(this, b.id)}>
                <div className="block-tool-bar">
                  <div className="grab-handle draggable-handle"></div>
                  <button className="block__delete-button" onClick={this.handleDeleteBlock.bind(this, b.id)}>x</button>

                  <input type="checkbox"
                    checked={selectedBlocks[b.id] || false}
                    onChange={this.handleToggleSelection.bind(this, b.id)}
                    className="block__select-checkbox"></input>
                </div>

                  <Blocks
                    key={b.id}
                    id={b.id} block={b}>
                  </Blocks>

              </div>
              )
            })}
          </ReactGridLayout>
        </div>

        {/* <MenuCustomCSS /> */}

        <MenuLibrary categories={this.state.categories} menu={this.state.menu}/>
      </div>
      </StorageContext.Provider>
    )
  }
}

export default MenuMaker;
export {StorageContext}
